import { ShopRendererDraftApiClient } from '@fourthwall/services/dist/ShopRendererDraftApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useSystemPageLayoutQuery = createQueryHook(ShopRendererDraftApiClient.getLayout, {
  queryKey: ['systemPageLayout'],
})
